import { render, staticRenderFns } from "./uploadPicBox.vue?vue&type=template&id=568554fc&scoped=true&"
import script from "./uploadPicBox.vue?vue&type=script&lang=js&"
export * from "./uploadPicBox.vue?vue&type=script&lang=js&"
import style0 from "./uploadPicBox.vue?vue&type=style&index=0&id=568554fc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "568554fc",
  null
  
)

export default component.exports